export const CREATE_JOB_WORK_RECEIVE = 'CREATE_JOB_WORK_RECEIVE';
export const GET_JOB_WORK_RECEIVE = 'GET_JOB_WORK_RECEIVE';
export const JOB_WORK_RECEIVE_REQUEST = 'JOB_WORK_RECEIVE_REQUEST';
export const JOB_WORK_RECEIVE_REQUEST_SUCCESS = 'JOB_WORK_RECEIVE_REQUEST_SUCCESS';
export const UPDATE_JOB_WORK_RECEIVE = 'UPDATE_JOB_WORK_RECEIVE';
export const DELETE_JOB_WORK_RECEIVE = 'DELETE_JOB_WORK_RECEIVE';
export const JOB_WORK_RECEIVE_REQUEST_FAILURE = 'JOB_WORK_RECEIVE_REQUEST_FAILURE';
export const GET_JOB_WORK_RECEIVES_PAGE = 'GET_JOB_WORK_RECEIVES_PAGE';
export const JOB_WORK_RECEIVE_TRANSACTION_AVAILABLE_REQUEST = 'JOB_WORK_RECEIVE_TRANSACTION_AVAILABLE_REQUEST';
export const JOB_WORK_RECEIVE_TRANSACTION_AVAILABLE_REQUEST_FAILURE = 'JOB_WORK_RECEIVE_TRANSACTION_AVAILABLE_REQUEST_FAILURE';
export const GET_JOB_WORK_RECEIVE_AVAILABLE_TRANSACTIONS = 'GET_JOB_WORK_RECEIVE_AVAILABLE_TRANSACTIONS';
export const RESET_JOB_WORK_RECEIVE_AVAILABLE_TRANSACTIONS = 'RESET_JOB_WORK_RECEIVE_AVAILABLE_TRANSACTIONS';

